export default "__VITE_ASSET__354ff77c__"